import { MouseEventHandler, ReactNode } from 'react';
import { BoundingBox, DrawnMol, Mol, Vector } from '@moleculeone/types';

import { styled } from '../../../stitches.config';
import { BaseCompound } from '../Compound/BaseCompound';

export interface ReagentCompoundRenderProps {
  mol: Mol;
  drawnMol: DrawnMol;
  size: number[];
  after: ReactNode;
  index: number;
  onClick: MouseEventHandler;
}

export type ReagentCompoundRenderer = (renderProps: ReagentCompoundRenderProps) => ReactNode;

export interface ReagentProps {
  className: string;
  size: number;
  mol: Mol;
  drawnMol: DrawnMol;
  circle: ReactNode;
  interactive: boolean;
  bbox: BoundingBox;
  index: number;
  renderCompound?: ReagentCompoundRenderer;
  onClick?: MouseEventHandler;
}

const StyledReagent = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignitems: 'center',
  height: '100%',
  variants: {
    interactive: {
      true: {
        '&:hover': {
          cursor: 'pointer',
        },
        '&:hover .svg-mol-space': {
          backgroundColor: '#ebf1f5',
        },
        '&:hover .atom-bg': {
          fill: '#ebf1f5',
        },
        '&:hover .atom-container': {
          stroke: '#ebf1f5',
        },
      },
    },
  },
});

function renderDefaultCompound(renderProps: any) {
  const { drawnMol, size, after, onClick } = renderProps;

  return <BaseCompound drawnMol={drawnMol} size={size} after={after} onMouseUp={onClick} />;
}

export function Reagent(props: ReagentProps) {
  const {
    className,
    size,
    mol,
    drawnMol,
    circle,
    interactive,
    bbox,
    index,
    renderCompound = renderDefaultCompound,
    onClick = () => {},
    ...restProps
  } = props;

  return (
    <StyledReagent
      {...restProps}
      className={className}
      interactive={interactive}
      css={{
        '& .svg-mol-space': {
          width: `${size}rem`,
          height: `${size}rem`,
          maxWidth: `${size}rem`,
          maxHeight: `${size}rem`,
        },
      }}
      data-reagent-idx={index}
    >
      {renderCompound({
        mol,
        drawnMol,
        size: bbox.size as Vector,
        after: circle,
        index,
        onClick,
      })}
    </StyledReagent>
  );
}

// Reagent.propTypes = {
//   className: PropTypes.string,
//   size: PropTypes.number,
//   mol: PropTypes.object,
//   drawnMol: PropTypes.object,
//   circle: PropTypes.node,
//   bbox: PropTypes.object,
//   index: PropTypes.number,
//   renderCompound: PropTypes.func,
//   onClick: PropTypes.func,
// };
